// extracted by mini-css-extract-plugin
export default {"host":"MobilePage_host__slLQO"};